import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotificationsEffects } from './+state/notifications.effects';
import { NotificationsFacade } from './+state/notifications.facade';
import {
  NOTIFICATIONS_FEATURE_KEY,
  reducer,
} from './+state/notifications.reducer';
import { LoadUnreadNotificationsGuard } from './guards/load-unread-notifications.guard';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(NOTIFICATIONS_FEATURE_KEY, reducer),
    EffectsModule.forFeature([NotificationsEffects]),
  ],
})
export class AppNotificationsModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppNotificationsModule
  ) {
    if (parentModule) {
      throw new Error(
        'AppNotificationsModule is already loaded. Import only in AppModule'
      );
    }
  }

  static forRoot(): ModuleWithProviders<AppNotificationsModule> {
    return {
      ngModule: AppNotificationsModule,
      providers: [NotificationsFacade, LoadUnreadNotificationsGuard],
    };
  }
}
